import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addProfileForm,
  editProfileForm,
  readProfileFormByProfileId,
  removeProfileForm,
} from "./thunkAction";

const initialState = {
  profileForm: null,
  loading: false,
  error: null,
  isLoadingAddProfileForm: false,
  addProfileFormError: null,
};

const profileFormSlice = createSlice({
  name: "profileFormManage",
  initialState,
  reducers: {
    clearProfileForm(state) {
      state.profileForm = null;
    },
    setProfileForm(state, action) {
      state.profileForm = _.get(action, "payload", {});
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // readProfileFormByProfileId
      .addCase(readProfileFormByProfileId.pending, (state) => {
        state.loading = true;
      })
      .addCase(readProfileFormByProfileId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.profileForm = _.get(action, "payload", {});
      })
      .addCase(readProfileFormByProfileId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addProfileForm
      .addCase(addProfileForm.pending, (state) => {
        state.isLoadingAddProfileForm = true;
        state.addProfileFormError = null;
      })
      .addCase(addProfileForm.fulfilled, (state, action) => {
        state.isLoadingAddProfileForm = false;
        state.profileForm = _.get(action, "payload", {});
      })
      .addCase(addProfileForm.rejected, (state, action) => {
        state.isLoadingAddProfileForm = false;
        state.addProfileFormError = action.payload;
      })
      // editProfileForm
      .addCase(editProfileForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileForm.fulfilled, (state, action) => {
        state.loading = false;
        state.profileForm = _.get(action, "payload", {});
      })
      .addCase(editProfileForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeProfileForm
      .addCase(removeProfileForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeProfileForm.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeProfileForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileFormReducer = profileFormSlice.reducer;

export const profileFormAction = profileFormSlice.actions;
